import React, { useEffect, useMemo, useState } from "react";
import { initialPath } from "~misc/paths";
import { CalendarIcon, CheckCircleIcon } from "~misc/icons";
import Instrucoes from "./Instrucoes";
import PainelSimulacao from "./PainelSimulacao";
import Loader from "~components/Form/components/Loader";
import LoaderFull from "~components/Form/components/LoaderFull";
import ModalDescontoSimuladoNaoAprovado from "../modals/ModalDescontoSimuladoNaoAprovado";
import useSimulatorsNewProduct from "../../hooks/useSimulatorsNewProduct";
import ModalInfosAdicionais from "../modals/ModalInfosAdicionais";
import ModalResponse from "~components/Modal/ModalResponse";
import TopoAreaSimulacao from "./TopoAreaSimulacao";
import ModalSimulacaoPDF from "../modals/ModalSimulacaoPDF";
import { useGetBeneficioFiscal } from "../../hooks/useSimulatorsQuery";
import useDefaultFetch from "~/fetchs/useDefaultFetch";
import { useGetSimulacoes } from "~/hooks/useSincronizacao";
import useSimulation from "../../hooks/useSimulation";
import useHeader from "~/components/Header/hooks/useHeader";
import { format } from "date-fns";
import { db } from "~/db/db";
import useSimulacaoHook from "~pages/Simulators/hooks/useSimulacaoHook";
import useUsuario from "~fetchs/useUsuario";

const AreaSimulacao = ({ cliente, simulacao, simulador, isLoading, desconto, setManualIdSimulacao }) => {
  const [isOpenModalResponse, setIsOpenModalResponse] = useState(false);
  const [openModalSendResponse, setOpenModalSendResponse] = useState({ isOpen: false, message: "" });
  const [openModalSucessResponse, setOpenModalSucessResponse] = useState({ isOpen: false, message: "", link: false });
  const [modalErrorResponse, setModalErrorResponse] = useState({ isOpen: false, message: "" });
  const { usuario } = useUsuario();
  const [loading, setLoading] = useState(false);
  const [loadingBeneficio, setLoadingBeneficio] = useState(false);
  const [enabled, setEnabled] = useState(null);
    // const [values, setValues] = useState({
    //   fracionario: null,
    //   descarga: null,
    // });
  const { processLastFetchTime } = useHeader();
  const {
    finished: finishedSimulacoes,
    refetching,
    loadingSync,
    newEnabled,
  } = useDefaultFetch({
    useGet: useGetSimulacoes,
    table: "simulacoes",
    enabled: enabled,
    processLastFetchTime,
  });

  const {
    isOpenDescontoSimuladoNaoAprovado,
    onOpenDescontoSimuladoNaoAprovado,
    onCloseDescontoSimuladoNaoAprovado,
    isOpenInfosAdicionais,
    onOpenInfosAdicionais,
    onCloseInfosAdicionais,
  } = useSimulatorsNewProduct();

  const {
    simulacaoAtualizada,
    grupos,
    todosOsProdutos,
    getTodayDate,
    calcCif,
    calcCifModal,
    values,
    setValues
  } = useSimulacaoHook(simulacao, desconto, cliente);

  const [modalPdf, setModalPdf] = useState(false);
  const onConfirmInfosAdicionais = (data) => {
    // redirect para a pagina de listagem de simulacoes
    onCloseInfosAdicionais();
    setOpenModalSendResponse({ isOpen: data?.isSuccess, message: data?.message });
  };

  const onErrorInfosAdicionais = (data) => {
    setModalErrorResponse({ isOpen: !data?.isSuccess, message: data?.message });
  };

  const onSaveDescontosSimuladosNaoAprovados = () => {
    // salvar os dados
    onCloseDescontoSimuladoNaoAprovado();
    setModalPdf(true);
  };

  const [beneficioEnable, setBeneficioEnable] = useState(false);

  const [simulacaoId, setSimulacaoId] = useState(simulacao.simulacaoId);
  useEffect(() => {
    setSimulacaoId(simulacao.simulacaoId);
  }, [simulacao.simulacaoId]);
  const beneficioFiscal = useGetBeneficioFiscal(simulacaoId, beneficioEnable);

  const onSuccess = (data) => {
    if (!simulacao.simulacaoId) {
      setSimulacaoId(data.id);
    }

    if (beneficioEnable) beneficioFiscal.refetch();
    else setBeneficioEnable(true);
  };

  const onError = () => {
    setLoadingBeneficio(false);
  };

  const { handleSubmit } = useSimulation({ simulacao, onSuccess, onError });

  function atualizaBeneficioFiscal() {
    setLoadingBeneficio(true);
    handleSubmit();
  }

  useEffect(() => {
    if (
      beneficioFiscal.data &&
      beneficioFiscal.isFetched &&
      !beneficioFiscal.isLoading &&
      !beneficioFiscal.isFetching
    ) {
      let messageErro = false;

      if (beneficioFiscal?.data && Array.isArray(beneficioFiscal?.data)) {
        messageErro = (beneficioFiscal?.data || [])?.find((bf) => bf?.innerResponse && bf?.innerResponse != null);
      } else if (beneficioFiscal?.data && beneficioFiscal?.data?.status) {
        messageErro = !beneficioFiscal?.data?.isSuccess;
      }

      if (messageErro) {
        beneficioFiscal.clearCache();
        setModalErrorResponse({
          isOpen: true,
          message: messageErro?.innerResponse.replace(/<br\s*\/?>/gi, '\n') || "Não foi possível calcular o beneficio fiscal!",
        });
        setLoadingBeneficio(false);
        setBeneficioEnable(false);
      } else {
        const simulacaoes = (beneficioFiscal?.data || [])?.reduce((acc, bf) => {
          if (bf?.simulacao)
            acc.push(...bf.simulacao)

            return acc;
        }, []);

        if (simulacaoes && simulacaoes.length) {
          db.simulacoes
            .bulkPut(simulacaoes)
            .then(() => {
              setLoadingBeneficio(false);

              if (beneficioEnable) {
                const simulacaoId = simulacao?.simulacaoId || simulacaoes[0].simulacaoId;
                setManualIdSimulacao(simulacaoId);
                setOpenModalSucessResponse({
                  isOpen: true,
                  message: "Benefício Fiscal aplicado com Sucesso!",
                  link: (cliente?.id && simulacaoId) ? `${initialPath}/simuladores/${cliente?.id}/simulacao/${simulacaoId}` : null,
                });
              }
            })
            .catch((e) => {
              console.error(e);
            });
        }
      }
    }
  }, [beneficioFiscal.data, beneficioFiscal.isFetched, beneficioFiscal.isLoading, beneficioFiscal.isRefetching]);

  return (
    <>
      {(loading || loadingBeneficio) && (
        <>
          <div className="spinner__form ">
            <LoaderFull />
          </div>
        </>
      )}

      <div className="container bg-white p-4 rounded-lg">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-2xl title__simulators p-3">
              Simulador: <strong className="font-bold">Ensacados</strong>
            </h3>
          </div>
          {simulacao?.createdAt && (
            <div className="flex gap-x-2 items-center justify-end text-lg">
              <CalendarIcon />
              <p>Data: {format(new Date(simulacao?.createdAt), "dd/MM/yyyy - HH:mm")}</p>
            </div>
          )}
        </div>
        <TopoAreaSimulacao simulador={simulador} cliente={cliente} values={values} setValues={setValues} />

        {(simulacao?.gruposProduto || []).length > 0 ? (
          <PainelSimulacao
            simulacao={simulacao}
            cliente={cliente}
            simulador={simulador}
            setIsOpenModalResponse={setIsOpenModalResponse}
            setLoading={setLoading}
            setEnabled={setEnabled}
            enabled={enabled}
            finishedSimulacoes={finishedSimulacoes}
            refetching={refetching}
            loadingSync={loadingSync}
            newEnabled={newEnabled}
            beneficioEnable={beneficioEnable}
          />
        ) : (
          <Instrucoes setIsOpenModalResponse={setIsOpenModalResponse} />
        )}

        {(simulacao?.gruposProduto || []).length > 0 && (
          <div className="flex items-center justify-center gap-x-4 gap-y-4 md:grid-cols-1 lg:grid-cols-2 mt-6 pb-8 mb-[120px]">
            <button
              className={`button-search flex justify-center items-center py-5 px-10 border-solid border-2 rounded-lg gap-1 font-bold text-lg ${
                beneficioEnable
                  ? "border-secundaria bg-secundaria text-white hover:text-white gap-3 cursor-not-allowed"
                  : "border-primaria text-primaria hover:text-white hover:bg-primaria"
              }`}
              disabled={beneficioEnable}
              onClick={atualizaBeneficioFiscal}
            >
              {beneficioEnable && <CheckCircleIcon className="grayscale brightness-[100] w-6 h-6" />}
              Simular com Benefício Fiscal
            </button>
            <button
              className="button-search flex justify-center items-center py-5 px-10 bg-primaria text-white rounded-lg gap-1 font-bold text-lg "
              onClick={onOpenDescontoSimuladoNaoAprovado}
            >
              Enviar para o cliente
            </button>
          </div>
        )}
      </div>

      <ModalDescontoSimuladoNaoAprovado
        isOpen={isOpenDescontoSimuladoNaoAprovado}
        onClose={onCloseDescontoSimuladoNaoAprovado}
        onConfirm={() => onOpenInfosAdicionais()}
        onSave={onSaveDescontosSimuladosNaoAprovados}
        simulacao={simulacao}
        cliente={cliente}
      />
      <ModalInfosAdicionais
        isOpen={isOpenInfosAdicionais}
        onClose={onCloseInfosAdicionais}
        onConfirm={onConfirmInfosAdicionais}
        onErrorResponse={onErrorInfosAdicionais}
        simulacao={simulacao}
      />
      <ModalSimulacaoPDF
        setValues={setValues}
        isOpen={modalPdf}
        onClose={() => {
          setModalPdf(false)
        }}
        // simulacaoItem={simulacao}
        // simuId={simulacao.simulacaoId}
        desconto={desconto}
        simulacaoAtualizada={simulacaoAtualizada}
        grupos={grupos}
        values={values}
        simulacao={simulacao}
        calcCif={calcCif}
        cliente={cliente}
        calcCifModal={calcCifModal}
        todosOsProdutos={todosOsProdutos}
        usuario={usuario}
        getTodayDate={getTodayDate}



      />

      <ModalResponse
        isOpen={openModalSendResponse?.isOpen}
        status={"success"}
        message={openModalSendResponse?.message || "Enviado para o portal de aprovação!"}
        closeModal={() => setOpenModalSendResponse({ isOpen: false, message: "" })}
        link={cliente?.id ? `${initialPath}/simuladores/simulacoes/${cliente.id}` : `${initialPath}/simuladores`}
      />

      <ModalResponse
        isOpen={openModalSucessResponse?.isOpen}
        status={"success"}
        message={openModalSucessResponse?.message || "Operação realizada com sucesso!"}
        closeModal={() => setOpenModalSucessResponse({ isOpen: false, message: "" })}
        link={openModalSucessResponse.link ? openModalSucessResponse.link : null}
      />

      <ModalResponse
        isOpen={isOpenModalResponse}
        status={"success"}
        message={"Os dados foram salvos!"}
        closeModal={() => setIsOpenModalResponse(false)}
        link={`${initialPath}/simuladores`}
      />

      <ModalResponse
        isOpen={modalErrorResponse?.isOpen}
        status={"warning"}
        message={
        modalErrorResponse?.message?.includes('<br')
          ? modalErrorResponse.message
              .split(/<br\s*\/?>/gi)
              .map((line, index) => (
                <span key={index}>
                  {line}
                  <br />
                </span>
              ))
          : modalErrorResponse?.message || "Ocorreu um erro ao processar a solicitação!"
      }
        closeModal={() => setModalErrorResponse({ isOpen: false, message: "" })}
      />
    </>
  );
};

export default AreaSimulacao;
